<div class="col-4" *ngIf="isRunning">
  <button type="button" class="btn btn-lg primary longSubmit" (click)="openPlayer('erase')">Classification</button>
</div>
<div class="col-4" *ngIf="!isRunning">
  <button type="button" class="btn btn-lg secondary" (click)="openmodal()">
    <span class="text-span" i18n="modal_classification|@@classification">Classification</span>
  </button>
</div>


<ng-template #content>
  <div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <img src="../../../assets/icon/close-modal.svg" class="close" aria-label="Close"
            (click)="modalRef.dismiss('Cross click')" />
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <span class="title" i18n="modal_classification|@@classification_by_damage">Classification par type de dommage :</span>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="row m-0 p-0" *ngFor="let item of finderData.admin.searchTagList.damageTag">
            <div class="col-12 m-0 p-0" *ngIf="item.value !== '+added' && item.value !== '+other'">
              <label class="checkbox-container">
                <input type="checkbox" id="{{item.value}}" [(ngModel)]="item.checked">
                <span class="checkmark"></span>{{item.display}}</label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-lg primary" i18n="modal_classification|@@cancel"
      (click)="modalRef.dismiss('Cross click')">Annuler</button>
    <button type="button" *ngIf="oneTagIsTrue()" class="btn btn-lg primary" i18n="modal_classification|@@save"
      (click)="modalRef.close('Save click')">Valider</button>
  </div>
</ng-template>


// WEBPACK FOOTER //
// ./src/app/element/classification/classification.component.html